module.exports = __webpack_public_path__ + "static/media/mail-ico.1317d6ed.svg";